import { createSlice } from "@reduxjs/toolkit";

const upiTxnAnalysisSlice = createSlice({
    name: "upiTxnAnalysis",
    initialState: {
        upiTxnAnalysisDetails: null,
        upiTxnAnalysisError: null,
        upiTxnAnalysisLoading: false,
    },
    reducers: {
        setUPITxnAnalysisDetails: (state, { payload }) => {
            state.upiTxnAnalysisDetails = payload;
        },
        setUPITxnAnalysisError: (state, { payload }) => {
            state.upiTxnAnalysisError = payload;
        },
        setUPITxnAnalysisLoading: (state, { payload }) => {
            state.upiTxnAnalysisLoading = payload;
        },
    }
});

export const { setUPITxnAnalysisDetails, setUPITxnAnalysisError, setUPITxnAnalysisLoading } = upiTxnAnalysisSlice.actions;

export default upiTxnAnalysisSlice.reducer;